
import { BarcodeType, getBarcodeTypesSelectItems, SaleLayoutBarcode } from "@/utils/sale-layouts/barcode";
import Vue from "vue";
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import AppSelectPlacement from "./SelectPlacement.vue";
import AppPropSelectAutocomplete from "@/components/prop-select/PropSelectAutocomplete.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSaleMapPropSelectGroup } from "@/utils/prop-select/sale-map-prop-group";
import { getSaleInSaleLayoutPropSelectGroup } from "@/utils/prop-select/sale-in-sale-layout-prop-group";
import { Condition } from "@/utils/condition/condition";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import AppFieldConditionEdit from "../models/ConditionEdit.vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			val: new SaleLayoutBarcode(),
			hiddenKeys: [] as string[],
		};
	},
	props: {
		value: {
			type: Object as ()=>SaleLayoutBarcode,
			required: true
		},
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		},
		lang: String
	},
	computed: {
		props(): PropSelectGroup {
			return getSaleMapPropSelectGroup();
		},
		conditionProps():PropSelectGroup{
			return getSaleInSaleLayoutPropSelectGroup();
		},
		barcodeTypeItems():ISelectItem<BarcodeType>[]{
			return getBarcodeTypesSelectItems();
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		save(){
			this.$emit("input", this.val.getJSON());
			this.close();
		},
		selectLang(val:string){
			this.$emit("lang", val);
		},
		async addCondition(){
			let condition = new Condition();
			this.hiddenKeys.push(condition.key);
			this.val.Conditions.push(condition);
			await this.$nextTick();
			this.hiddenKeys.pop();
		},
		removeCondition(i:number){
			this.val.Conditions.splice(i,1);
		},
		shouldShowKey(key:string):boolean{
			return this.hiddenKeys.indexOf(key) == -1;
		}
	},
	mounted(){
		this.val = new SaleLayoutBarcode(this.value.getJSON());
		this.val.uuid = this.value.uuid;
	},
	components: {
		AppCustomLangSelect,
		AppSelectPlacement,
		AppPropSelectAutocomplete,
		AppFieldConditionEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
